import type { ReportProvider, ReportDataset, DatasetOptions, MetricId, ReportFilter } from '../types'
import { engineApi } from '../../../sdk/engine.api'
import { metricsDataset } from '../engine/dataset'

const SUPPORTED_METRICS: MetricId[] = [
  'pending', 'assigned', 'ready',
  'upsellOrders', 'upsellRevenue',
  'noAnswer', 'notInterested', 'conversionRate',
]

export const SalesReportProvider: ReportProvider = {
  id:                   'sales',
  label:                'Sales',
  workflowId:           'sales',
  supportedMetrics:     SUPPORTED_METRICS,
  supportedDimensions:  ['date', 'agent', 'team', 'status', 'outcome'],
  supportedFilters:     ['date_range', 'preset', 'teams', 'members', 'status', 'multi_select'],
  supportedExports:     ['csv', 'excel', 'json', 'pdf'],
  defaultFilter:        { workflows: ['sales'] },

  async buildDataset(shop: string, filter: ReportFilter, options?: DatasetOptions): Promise<ReportDataset> {
    const data = await engineApi.metrics(shop, 'sales')

    const upsell      = data.closedToday.byOutcome['sales_upsell_created']       ?? 0
    const reConfirmed = data.closedToday.byOutcome['sales_re_confirmed']          ?? 0
    const newOrder    = data.closedToday.byOutcome['sales_new_order_created']     ?? 0
    const noAnswer    = data.closedToday.byOutcome['no_answer']                   ?? 0
    const notInt      = data.closedToday.byOutcome['sales_not_interested']        ?? 0
    const closedTotal = data.closedToday.total
    const ready       = upsell + reConfirmed + newOrder
    const convRate    = closedTotal > 0 ? ready / closedTotal : 0

    const current: Record<string, number> = {
      pending:        data.queued,
      assigned:       data.active,
      ready,
      upsellOrders:   upsell,
      upsellRevenue:  0,
      noAnswer,
      notInterested:  notInt,
      conversionRate: convRate,
    }

    // Period comparisons (today vs yesterday, month-to-date vs last month) require
    // a date-range metrics endpoint — not yet built. Comparisons are omitted until
    // GET /engine/workflows/:id/metrics?from=&to= is added in Stage 8 continuation.

    return metricsDataset('sales', 'sales', filter, current, undefined, options)
  },
}
